import React from 'react'
import { DEFAULT_THEME, THEMES } from '../constants'
import { StyledEngineProvider } from '@mui/styled-engine-sc'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import createTheme from '../theme'
import { useLanguage } from './LanguageContext'

const LOCAL_STORAGE_KEY = 'theme'
export interface ThemeState {
  theme: string
  setTheme: (theme: string) => void
}

export const ThemeContext = React.createContext({
  theme: DEFAULT_THEME,
  setTheme: (theme: string) => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, theme)
  }
})

export interface ThemeProviderProps {
  children: React.ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { language } = useLanguage()

  const getInitialTheme = () => {
    let storedTheme = localStorage.getItem(LOCAL_STORAGE_KEY) ?? THEMES.DARK

    if (storedTheme === '"LIGHT"') {
      storedTheme = THEMES.LIGHT
      localStorage.setItem(LOCAL_STORAGE_KEY, THEMES.LIGHT)
    } else if (storedTheme === '"DARK"') {
      storedTheme = THEMES.DARK
      localStorage.setItem(LOCAL_STORAGE_KEY, THEMES.DARK)
    }

    return storedTheme ? storedTheme : THEMES.DARK
  }

  const [theme, _setTheme] = React.useState<string>(getInitialTheme())

  const setTheme = (theme: string) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, theme)
    _setTheme(theme)
  }

  const muiTheme = createTheme(theme, language)

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={muiTheme}>
          <StyledThemeProvider theme={muiTheme}>{children}</StyledThemeProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </ThemeContext.Provider>
  )
}
